import PrimaryButton from '@/components/PrimaryButton/PrimaryButton'
import useGrubhubGetFoodOrder from '@/lib/food-grubhub/hooks/useGrubhubGetFoodOrder'

import style from './FoodOrderDetails.module.scss'
import FoodOrderItem from './FoodOrderItem'

export default memo(function FoodOrderDetails() {
  const navigate = useNavigate()
  const {foodOrderId} = useParams({strict: false})

  const {data: order, isLoading, error} = useGrubhubGetFoodOrder(foodOrderId ?? '')

  if (isLoading) {
    return (
      <main className={style.OrderDetailsSection}>
        <div className={style.LoadingText}>Loading order details...</div>
      </main>
    )
  }

  if (error || !order) {
    return (
      <main className={style.OrderDetailsSection}>
        <div className={style.ErrorText}>Failed to load order details. Please try again.</div>
      </main>
    )
  }

  return (
    <main className={style.OrderDetailsSection}>
      <PrimaryButton
        className={style.GoBack}
        onPress={() => {
          void navigate({to: '/food-orders'})
        }}
      >
        Back
      </PrimaryButton>

      <h1 className={style.Heading}>Food Order Details</h1>

      <FoodOrderItem order={order} isShowingDetails />
    </main>
  )
})
